import Head from 'next/head';

import ForgotPassword from '../../components/authentication/ForgotPassword';
import AccountSetupLayout from '../../components/authentication/AccountSetupLayout';
import BrandLayout from '../../components/brand/BrandLayout';

const Password = () => {
  return (
    <BrandLayout>
      <AccountSetupLayout type="forgotPassword">
        <Head>
          <title>AfricaSasa Merchant | Set Password</title>
        </Head>
        <ForgotPassword />
      </AccountSetupLayout>
    </BrandLayout>
  );
};

export default Password;
